import { render } from "./ElMobileNavigation.vue?vue&type=template&id=35c5ac6a&lang=html"
import script from "./ElMobileNavigation.vue?vue&type=script&lang=js"
export * from "./ElMobileNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__